import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';

interface AuthenticationProps {
  readonly authenticated: boolean;
}

type Props = AuthenticationProps & RouteProps;

const PrivateRoute: React.FC<Props> = ({ authenticated, location, ...props }: Props) => {
  if (!authenticated) {
    const toRoute = {
      pathname: '/login',
      state: { from: location },
    };

    return <Redirect to={toRoute} />;
  }

  return <Route {...props} />;
};

export default PrivateRoute;
